import { useEffect, useId, useState } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";

let activeId = null;
const listeners = new Set();

const HIDDEN_SIDEBAR_PREFIXES = [
  "/store",
  "/create_doubt",
  "/tutor",
  "/tutor-session",
  "/subject_component",
  "/topic_component",
  "/profile",
  "/user_profile",
  "/user_edit_profile",
  "/wallet",
  "/user_attendance",
  "/attendance",
  "/package_overview",
  "/package",
  "/notes",
  "/videos",
  "/streaming",
];

const shouldHideSidebar = (pathname) =>
  HIDDEN_SIDEBAR_PREFIXES.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`)
  );

const notify = () => {
  listeners.forEach((fn) => fn(activeId));
};

const AppSidebar = () => {
  const id = useId();
  const { pathname } = useLocation();
  const [ownerId, setOwnerId] = useState(activeId);

  useEffect(() => {
    const sync = (nextId) => setOwnerId(nextId);
    listeners.add(sync);

    if (activeId === null) {
      activeId = id;
      notify();
    } else {
      setOwnerId(activeId);
    }

    return () => {
      listeners.delete(sync);
      if (activeId === id) {
        activeId = null;
        notify();
      }
    };
  }, [id]);

  useEffect(() => {
    if (ownerId === null && activeId === null) {
      activeId = id;
      notify();
    }
  }, [ownerId, id]);

  if (shouldHideSidebar(pathname) || ownerId !== id) return null;
  return <Sidebar variant="drawer" />;
};

export default AppSidebar;
